import React, { useMemo } from 'react'

import { TableSortType } from 'src/components/molecules'
import { InternalAssignUserSortItemType } from 'src/components/molecules/projects/InternalAssignUserTableHead'
import { InternalAssignUserTableRow } from 'src/components/molecules/projects/InternalAssignUserTableRow'

import { useGetUsers } from 'src/hooks'
import { ProfileEntity, ProjectAssignUserEntity } from 'src/types'

type Props = {
  profile?: ProfileEntity
  internalAssignedUsers: ProjectAssignUserEntity[]
  sortItem: InternalAssignUserSortItemType
  sortType: TableSortType
  className?: string
}

export function InternalAssignUserTableBody({
  profile,
  internalAssignedUsers,
  sortItem,
  sortType,
  className,
}: Props) {
  const { users: internalUsers } = useGetUsers()

  const sortedInternalUsers = useMemo(() => {
    return [...internalAssignedUsers].sort((a, b) => {
      const order = sortType === 'desc' ? 1 : -1

      if (sortItem === 'name') {
        return (a.name ?? '-') < (b.name ?? '-') ? order : -order
      }
      if (sortItem === 'email') {
        return (a.email ?? '-') < (b.email ?? '-') ? order : -order
      }
      if (sortItem === 'keywords') {
        const aKeywords = internalUsers.find(user => user.id === a.id)?.keywords
        const aTargetKeywords = aKeywords && aKeywords.length > 0 ? aKeywords[0] : '-'
        const bKeywords = internalUsers.find(user => user.id === b.id)?.keywords
        const bTargetKeywords = bKeywords && bKeywords.length > 0 ? bKeywords[0] : '-'
        return aTargetKeywords < bTargetKeywords ? order : -order
      }
      if (sortItem === 'customRole') {
        const aCustomRole = internalUsers.find(user => user.id === a.id)?.customRoles
        const aTargetCustomRoleId = aCustomRole && aCustomRole.length > 0 ? aCustomRole[0].id : -1
        const bCustomRole = internalUsers.find(user => user.id === b.id)?.customRoles
        const bTargetCustomRoleId = bCustomRole && bCustomRole.length > 0 ? bCustomRole[0].id : -1
        return aTargetCustomRoleId < bTargetCustomRoleId ? order : -order
      }
      if (sortItem === 'assignedAt') {
        return a.assignedAt < b.assignedAt ? order : -order
      }
      if (sortItem === 'compassRole') {
        return a.compassRole.priority < b.compassRole.priority ? order : -order
      }

      return 0
    })
  }, [internalAssignedUsers, internalUsers, sortItem, sortType])

  return (
    <div className={className}>
      <ul>
        {sortedInternalUsers.map(internalUser => (
          <li
            className="tw-centering tw-border-b tw-border-b-border-secondary last:tw-border-b-0"
            key={internalUser.id}
          >
            <a
              href={`/users/${internalUser.id}`}
              className="hover:tw-bg-surface-secondary tw-bg-surface-primary tw-w-full"
              target="_blank"
              rel="noreferrer"
            >
              <InternalAssignUserTableRow
                internalUser={internalUser}
                profile={profile}
                className="tw-w-full"
              />
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
